import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "C:\\Users\\borja\\Desktop\\Cursor\\oro-express-academy\\components\\shared\\Navbar.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\borja\\Desktop\\Cursor\\oro-express-academy\\node_modules\\next\\dist\\client\\link.js");
